import Mockjs from 'mockjs'

export default {
  // 组题列表
  list: config => {
    return {
      counts: 3047,
      pagesize: 42,
      pages: 48,
      page: 69,
      items: [
        {
          id: '510000197405202172',
          addTime: '2008-01-19 14:53:18',
          userName: '龙杰',
          questionIDs: [
            '130000198111274342',
            '310000197712162783',
            '540000199209203631'
          ],
          progressOfAnswer: 29,
          accuracyRate: 62,
          totalSeconds: 4157,
          questionType: 'qui cillum fugiat Lorem culpa'
        },
        {
          id: '46000019850217584X',
          addTime: '2015-08-04 16:06:06',
          userName: '石霞',
          questionIDs: [
            '44000019750501615X',
            '460000201504309375',
            '330000197211120247'
          ],
          progressOfAnswer: 18,
          accuracyRate: 63,
          totalSeconds: 314,
          questionType: 'dolor amet'
        },
        {
          id: '320000199911176433',
          addTime: '2017-04-19 06:31:48',
          userName: '范丽',
          questionIDs: ['140000197601033856'],
          progressOfAnswer: 45,
          accuracyRate: 38,
          totalSeconds: 2337,
          questionType: 'Lorem adipisicing sed enim do'
        },
        {
          id: '450000201506222087',
          addTime: '1970-07-12 07:53:19',
          userName: '吴磊',
          questionIDs: [
            '65000019871129674X',
            '21000019800301253X',
            '710000197803082118',
            '130000199810066694',
            '430000200208123234'
          ],
          progressOfAnswer: 35,
          accuracyRate: 47,
          totalSeconds: 887,
          questionType: 'deserunt cillum'
        },
        {
          id: '44000019790426023X',
          addTime: '2011-12-01 17:22:10',
          userName: '唐超',
          questionIDs: [
            '50000019790202722X',
            '12000019751002845X',
            '810000199208162538'
          ],
          progressOfAnswer: 67,
          accuracyRate: 26,
          totalSeconds: 3089,
          questionType: 'aliquip dolor'
        },
        {
          id: '650000201611306431',
          addTime: '1976-07-28 23:23:45',
          userName: '钱秀英',
          questionIDs: [
            '220000201007207066',
            '210000200707288761',
            '370000201901248842'
          ],
          progressOfAnswer: 54,
          accuracyRate: 97,
          totalSeconds: 204,
          questionType: 'do'
        },
        {
          id: '130000198706036474',
          addTime: '1976-02-20 06:37:04',
          userName: '吴涛',
          questionIDs: [
            '150000197307047589',
            '450000199912256223',
            '120000197103035708'
          ],
          progressOfAnswer: 54,
          accuracyRate: 36,
          totalSeconds: 4250,
          questionType: 'labore exercitation occaecat dolore'
        },
        {
          id: '150000197009215150',
          addTime: '1979-05-29 05:57:01',
          userName: '石艳',
          questionIDs: ['420000200702248313'],
          progressOfAnswer: 62,
          accuracyRate: 90,
          totalSeconds: 4875,
          questionType: 'dolore'
        },
        {
          id: '530000197507264765',
          addTime: '2018-05-30 01:15:52',
          userName: '傅娜',
          questionIDs: [
            '410000199603232431',
            '220000197106036275',
            '340000198709217456',
            '320000201506276705'
          ],
          progressOfAnswer: 74,
          accuracyRate: 78,
          totalSeconds: 2465,
          questionType: 'nulla mollit aute'
        },
        {
          id: '120000201411197564',
          addTime: '2015-11-10 12:05:17',
          userName: '沈秀兰',
          questionIDs: [
            '510000200410298441',
            '220000198301313631',
            '220000201305049422'
          ],
          progressOfAnswer: 15,
          accuracyRate: 14,
          totalSeconds: 261,
          questionType: 'tempor do quis ad eiusmod'
        },
        {
          id: '610000199505194192',
          addTime: '2012-08-06 00:55:17',
          userName: '于平',
          questionIDs: [
            '820000201604200454',
            '610000197602072489',
            '130000199311014785'
          ],
          progressOfAnswer: 72,
          accuracyRate: 76,
          totalSeconds: 1580,
          questionType: 'nostrud cillum incididunt'
        },
        {
          id: '210000201210254253',
          addTime: '1994-03-01 07:55:21',
          userName: '谭强',
          questionIDs: ['360000198710241959', '53000019810206484X'],
          progressOfAnswer: 84,
          accuracyRate: 52,
          totalSeconds: 1074,
          questionType: 'dolor'
        },
        {
          id: '820000199208053413',
          addTime: '1977-07-27 05:06:07',
          userName: '孙伟',
          questionIDs: [
            '370000201207218440',
            '500000197508024936',
            '350000197707054566'
          ],
          progressOfAnswer: 11,
          accuracyRate: 54,
          totalSeconds: 3234,
          questionType: 'incididunt voluptate deserunt'
        },
        {
          id: '640000201501284452',
          addTime: '1976-07-28 18:35:10',
          userName: '孙平',
          questionIDs: [
            '710000199505153570',
            '540000201501273215',
            '420000198411037954',
            '370000198005079628'
          ],
          progressOfAnswer: 74,
          accuracyRate: 80,
          totalSeconds: 860,
          questionType: 'nostrud exer'
        },
        {
          id: '360000197405178629',
          addTime: '2001-09-01 07:38:43',
          userName: '沈磊',
          questionIDs: ['15000020150714194X', '12000020050120417X'],
          progressOfAnswer: 47,
          accuracyRate: 36,
          totalSeconds: 4220,
          questionType: 'off'
        },
        {
          id: '440000200201241352',
          addTime: '1997-06-11 17:04:05',
          userName: '熊磊',
          questionIDs: [
            '210000197202218333',
            '54000020000415494X',
            '610000201501118619',
            '530000199509171895'
          ],
          progressOfAnswer: 73,
          accuracyRate: 77,
          totalSeconds: 660,
          questionType: 'aliqua culpa'
        },
        {
          id: '320000201803205372',
          addTime: '2004-03-25 08:39:22',
          userName: '阎明',
          questionIDs: [
            '510000200012065431',
            '410000199702142781',
            '210000199004172898',
            '510000199808136324',
            '120000198805113736'
          ],
          progressOfAnswer: 80,
          accuracyRate: 67,
          totalSeconds: 3303,
          questionType: 'dolor non'
        },
        {
          id: '210000199411102117',
          addTime: '2016-06-05 06:22:26',
          userName: '吴军',
          questionIDs: [
            '640000197004295274',
            '420000198001053126',
            '520000198311133539',
            '330000197908281825'
          ],
          progressOfAnswer: 88,
          accuracyRate: 28,
          totalSeconds: 2928,
          questionType: 'voluptate'
        },
        {
          id: '510000201612171638',
          addTime: '1982-05-17 11:02:49',
          userName: '程娜',
          questionIDs: ['320000201309133959'],
          progressOfAnswer: 64,
          accuracyRate: 17,
          totalSeconds: 3243,
          questionType: 'sint labore'
        },
        {
          id: '620000199801262331',
          addTime: '1981-05-10 09:17:40',
          userName: '汪艳',
          questionIDs: [
            '140000198203044669',
            '210000200711116663',
            '650000199407125473'
          ],
          progressOfAnswer: 20,
          accuracyRate: 69,
          totalSeconds: 3536,
          questionType: 'deserunt eiusmod'
        }
      ]
    }
  },
  // 删除
  delete: config => {
    return {}
  }
}
